import { TransferenciaInterface } from '@/shared/models/transferencia/transferencia.interface';
import store from '@/store';
import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import { instanciaAxios } from '@/services/base.service';

export default class TransferenciaService {
  async getRegra(): Promise<any> {
    return await instanciaAxios.get('transferencia/regra')
      .then((response: any) => {
        const transferencia: TransferenciaInterface = response.data;
        return transferencia;
      });
  }

  async atualizarRegra(body: TransferenciaInterface): Promise<any> {
    await instanciaAxios.put('transferencia/regra', body)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Regra de transferência atualizada com sucesso!');
      });
  }
}
